export enum EditType {
  VARIANT = 'variant',
  ATTRIBUTE = 'attribute',
}
